// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__6Z_Bw","signatureBlock":"Footer_signatureBlock__2LJGu","signature":"Footer_signature__1S7OI"};